import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../Styles/CloudProRegisterPage.css';
import logo from '../Assets/icons/velox_logo.png';
import Axios from 'axios';
export default function CloudProRegister() {

    const mdId = localStorage.getItem("mdId");
console.log("mdId:", mdId);
    const [phoneCountries, setPhoneCountries] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedState, setSelectedState] = useState("");
    const [selectedCity, setSelectedCity] = useState("");

    // by default phone country code and country
    const [selected, setSelected] = useState({
        name: "India",
        code: "+91",
        flag: "in"
    });

    const [open, setOpen] = useState(false);
    const API_KEY = "NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA==";
    const BASE_URL = "https://api.countrystatecity.in/v1/countries";
    // below api is use phone number-country code and flag
    useEffect(() => {
        fetch("https://countriesnow.space/api/v0.1/countries/codes")
            .then(res => res.json())
            .then(data => {
                const formatted = data.data.map(c => ({
                    name: c.name,
                    code: c.dial_code,
                    flag: c.code.toLowerCase()
                }));
                setPhoneCountries(formatted);
            });
    }, []);

    // below api is for fetch list of all countries 
    useEffect(() => {
        fetch(BASE_URL, {
            headers: { "X-CSCAPI-KEY": API_KEY }
        })
            .then(res => res.json())
            .then(data => setCountries(data));
    }, []);

    // below functin use for load state for that particular country
    const handleCountryChange = (countryIso, countryName) => {
        setSelectedCountry(countryIso);
        setFormData(prev => ({ ...prev, country: countryName }));
        setStates([]);
        setCities([]);

        fetch(`${BASE_URL}/${countryIso}/states`, { headers: { "X-CSCAPI-KEY": API_KEY } })
            .then(res => res.json())
            .then(data => setStates(Array.isArray(data) ? data : data.data || []))
            .catch(err => setStates([]));
    };

    // below functin use for load cities for that particular state
    const handleStateChange = (stateIso, stateName) => {
        setSelectedState(stateIso);
        setFormData(prev => ({ ...prev, state: stateName }));
        setCities([]);

        fetch(`${BASE_URL}/${selectedCountry}/states/${stateIso}/cities`, { headers: { "X-CSCAPI-KEY": API_KEY } })
            .then(res => res.json())
            .then(data => setCities(Array.isArray(data) ? data : data.data || []))
            .catch(err => setCities([]));
    };

    const [registerError, setRegisterError] = useState("");
    const [registerSuccess, setRegisterSuccess] = useState("");
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        address: "",
        country: "",
        state: "",
        city: "",
        postal: ""
    });


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validate()) return;

        const fullPhoneNumber = `${selected.code}-${formData.phone}`;
        alert("-----formData.email----" + formData.email);
        alert("-----formData.company----" + formData.company);
        alert("-----formData.lastName----" + formData.lastName);
        alert("-----fullPhoneNumber----" + fullPhoneNumber);
        alert("-----selectedCountry----" + formData.country);
        alert("-----selectedState----" + formData.state);
        alert("-----selectedCity----" + formData.city);
        alert("-----formData.address----" + formData.address);
        alert("-----formData.postal----" + formData.postal);


        //   Axios.post(`/register`, {
        //     email: formData.email,
        //     companyname: formData.company,
        //     firstname: formData.firstName,
        //     lastname: formData.lastName,
        //     phone: fullPhoneNumber,
        //     country: selectedCountry, // use selectedCountry
        //     state: selectedState,     // use selectedState
        //     city: selectedCity,       // use selectedCity
        //     address: formData.address,
        //     postalcode: formData.postal,
        //   })
        //     .then((response) => {
        //       if (response.data.success) {
        //        setRegisterSuccess("Email verification successful, please register your YubiKey");
        //       } else {
        //        setRegisterError(response.data.msg);
        //       }
        //     })
        //     .catch((error) => {
        //      setRegisterError("Register error, please try again!");
        //       console.error("Register error:", error);
        //     });
    };

    // below code is for validate register and fields
    const validate = () => {
        let newErrors = {};


        if (!formData.firstName.trim()) {
            newErrors.firstName = "First name is required";
        }

        if (!formData.lastName.trim()) {
            newErrors.lastName = "Last name is required";
        }

        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Enter valid email";
        }

        if (!formData.phone.trim()) {
            newErrors.phone = "Phone number is required";
        }

        if (!formData.company.trim()) {
            newErrors.company = "Company name is required";
        }

        if (!formData.address.trim()) {
            newErrors.address = "Address is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({ ...formData, [name]: value });
        setErrors((prev) => ({
            ...prev,
            [name]: ""
        }));
    };

    return (
        <div className="main-container1">

            <div className="register-card1">

                <div className="logo-box1">
                    <img src={logo} alt="logo" />
                </div>

                <h2 className="title">Register Account</h2>
                <p className="subtitle">Fill in your details to register</p>
                <div className="input-row1">
                    <div className="input-group1">
                        <label>First Name</label>
                        <input
                            type="text"
                            name="firstName"
                            placeholder="Enter first name"
                            value={formData.firstName}
                            onChange={handleChange}
                            className={errors.firstName ? "input-error" : ""}
                        />

                        {errors.firstName && (
                            <p className="error-text">{errors.firstName}</p>
                        )}
                    </div>
                    <div className="input-group1">
                        <label>Last Name</label>
                        <input
                            type="text"
                            name="lastName"
                            placeholder="Enter last name"
                            value={formData.lastName}
                            onChange={handleChange}
                            className={errors.lastName ? "input-error" : ""}
                        />

                        {errors.lastName && (
                            <p className="error-text">{errors.lastName}</p>
                        )}
                    </div>
                </div>

               
                <div className="input-row1">
                    <div className="input-group1 flex-grow">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="Enter email"
                            value={formData.email}
                            onChange={handleChange}
                            className={errors.email ? "input-error" : ""}
                        />

                        {errors.email && (
                            <p className="error-text">{errors.email}</p>
                        )}
                    </div>
                    <button className="verify-btn">Verify</button>
                </div>

               
                <div className="input-row1">

                  
                    <div className="input-group1">
                        <label>Phone Number</label>

                        <div className="phone-field">

                           
                            <div className="country-code-box" onClick={() => setOpen(!open)}>
                                <img
                                    style={{ width: '15px' }}
                                    src={`https://flagcdn.com/w40/${selected.flag}.png`}
                                    alt="flag"
                                />
                                <span style={{ fontSize: '10px' }}>{selected.code}</span>
                            </div>

                            {open && (
                                <div className="country-dropdown">
                                    {phoneCountries.map((c, i) => (
                                        <div
                                            key={i}
                                            className="country-item"
                                            onClick={() => {
                                                setSelected(c);
                                                setOpen(false);
                                            }}
                                        >
                                            <img
                                                style={{ width: '15px' }}
                                                src={`https://flagcdn.com/w40/${c.flag}.png`}
                                                alt="flag"
                                            />
                                            {c.code} {c.name}
                                        </div>
                                    ))}
                                </div>
                            )}
                            <input
                                type="tel"
                                name="phone"
                                placeholder="Phone Number"
                                value={formData.phone}
                                onChange={handleChange}
                                className={`form-field ${errors.phone ? "input-error" : ""}`}
                            />


                        </div>
                        {errors.phone && (
                            <p className="error-text">{errors.phone}</p>
                        )}
                    </div>

                    <div className="input-group1">
                        <label>Company Name</label>
                        <input
                            type="text"
                            name="company"
                            placeholder="Enter company name"
                            value={formData.company}
                            onChange={handleChange}
                            className={errors.company ? "input-error" : ""}
                        />

                        {errors.company && (
                            <p className="error-text">{errors.company}</p>
                        )}
                    </div>
                </div>
                <div className="input-row1">
                    <div className="input-group1">
                        <label>Country</label>
                        <select
                            name="country"
                            value={formData.country || ""}
                            onChange={(e) => {
                                const selectedCountryName = e.target.options[e.target.selectedIndex].text;
                                const countryIso = countries.find(c => c.name === selectedCountryName)?.iso2 || "";
                                handleCountryChange(countryIso, selectedCountryName);
                            }}
                        >
                            <option value="">Select Country</option>
                            {countries.map((c) => (
                                <option key={c.iso2} value={c.name}>  
                                    {c.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="input-group1">
                        <label>State</label>
                        <select
                            name="state"
                            value={formData.state || ""}
                            onChange={(e) => {
                                const selectedStateName = e.target.options[e.target.selectedIndex].text;
                                const stateIso = states.find(s => s.name === selectedStateName)?.iso2 || "";
                                handleStateChange(stateIso, selectedStateName);
                            }}
                        >
                            <option value="">Select State</option>
                            {states.map((s) => (
                                <option key={s.iso2} value={s.name}>  
                                    {s.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

               
                <div className="input-row1">
                    <div className="input-group1">
                        <label>City</label>
                        <select
                            name="city"  
                            value={formData.city || ""}
                            onChange={(e) => {
                                const cityName = e.target.options[e.target.selectedIndex].text;
                                handleChange(e);               
                                setSelectedCity(cityName);      
                            }}
                            disabled={!cities.length}
                        >
                            <option>Select City</option>
                            {cities.map((c, i) => (
                                <option key={i}>{c.name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="input-group1">
                        <label>Postal Code</label>
                        <input type="number" placeholder="Enter postal" name="postal"

                            value={formData.postal}
                            onChange={handleChange}
                        />
                    </div>
                </div>

               
                <div className="input-group1">
                    <label>Address</label>
                    <textarea
                        name="address"
                        placeholder="Enter address"
                        value={formData.address}
                        onChange={handleChange}
                        className={errors.address ? "input-error" : ""}
                    />

                    {errors.address && (
                        <p className="error-text">{errors.address}</p>
                    )}
                </div>
                {registerSuccess && (
                    <p className="success-text">{registerSuccess}</p>
                )}

                {setRegisterError && (
                    <p className="error-text">{registerError}</p>
                )}
                <button className="signin-btn1" onClick={handleSubmit}>Register</button>

                <p className="bottom-text1">
                <span><Link to={`/${mdId}/cloudprologin`} className="red-link1">Back</Link></span>
                </p>

            </div>

            <p className="copyright1">
                © {new Date().getFullYear()} Velox Life Safety Inc. All rights reserved.
            </p>

        </div>
    );
}